// 이메일 인증

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useAlertStore from "store/alert";
import { useAuthEmailMutate } from "./service";

export const useAuthEmail = () => {
  const { t } = useTranslation();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { mutate } = useAuthEmailMutate();
  const { search } = useLocation();
  const onAuthEmail = () => {
    onSetAlert({
      isOpen: true,
      inner: t("alt_auth_eml"),
      cnclBtn: true,
      onSetConfirm: () => {
        mutate({
          certEncParam: search.replace("?param=", ""),
        });
      },
    });
  };

  return {
    onAuthEmail,
  };
};
